import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { format } from 'date-fns';

import NoResults from '../../../../components/reusable/no-results';
import SetOptionTable from '../../../../components/reusable/set-options-table/SetOptionTable';
import { SetOptionTableMode } from '../../../../components/reusable/set-options-table/interfaces';
import { IExercise } from '../../../../types/interfaces/exercise';
import { ITraining } from '../../../../types/interfaces/training';
import { useStyles } from './ExerciseHistory.styles';

interface IExerciseHistoryProps {
  trainings: ITraining[];
  exercise: IExercise;
}

export default function ExerciseHistory({
  trainings,
  exercise,
}: IExerciseHistoryProps) {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  return (
    <Box>
      {!trainings?.length && <NoResults />}
      {!!trainings?.length &&
        trainings.map((training) => (
          <Box key={training.id} marginBottom={2} marginTop={1}>
            <Typography variant="h2" fontWeight="bold" marginLeft={1}>
              {training.title}
            </Typography>
            <Typography
              variant="text-sm"
              color={theme.palette.font.secondary}
              marginLeft={1}>
              {training?.startDate &&
                format(new Date(training.startDate), 'dd.MM.yyyy')}
            </Typography>

            {training.trainingSets.map((set) => (
              <Box key={set.id} marginTop={2} className={classes.setWrapper}>
                <SetOptionTable
                  set={{ ...set, exercise }}
                  mode={SetOptionTableMode.training}
                  valueProperty="value"
                  canSaveSet={false}
                />
              </Box>
            ))}
          </Box>
        ))}
    </Box>
  );
}
